import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import ContentLayout from "../../components/ContentLayout";

// UGAM - 2024
import coCurricularEvent_2024_ugam_2024_img_1 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_1.jpg";
import coCurricularEvent_2024_ugam_2024_img_2 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_2.jpg";
import coCurricularEvent_2024_ugam_2024_img_3 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_3.jpg";
import coCurricularEvent_2024_ugam_2024_img_4 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_4.jpg";
import coCurricularEvent_2024_ugam_2024_img_5 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_5.jpg";
import coCurricularEvent_2024_ugam_2024_img_6 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_6.jpg";
import coCurricularEvent_2024_ugam_2024_img_7 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_7.jpg";
import coCurricularEvent_2024_ugam_2024_img_8 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_8.jpg";
import coCurricularEvent_2024_ugam_2024_img_9 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_9.jpg";
import coCurricularEvent_2024_ugam_2024_img_10 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_10.jpg";
import coCurricularEvent_2024_ugam_2024_img_11 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_11.jpg";
import coCurricularEvent_2024_ugam_2024_img_12 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_12.jpg";
import coCurricularEvent_2024_ugam_2024_img_13 from "../../assets/images/events/coCurricular/ugam-2024/coCurricularEvent_ugam_2024_img_13.jpg"
// Pro-contech - 2024
import coCurricularEvent_pro_conTech_2024_img_1 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_1.jpg";
import coCurricularEvent_pro_conTech_2024_img_2 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_2.jpg";
import coCurricularEvent_pro_conTech_2024_img_3 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_3.jpg";
import coCurricularEvent_pro_conTech_2024_img_4 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_4.jpg";
import coCurricularEvent_pro_conTech_2024_img_5 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_5.jpg";
import coCurricularEvent_pro_conTech_2024_img_6 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_6.jpg";
import coCurricularEvent_pro_conTech_2024_img_7 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_7.jpg";
import coCurricularEvent_pro_conTech_2024_img_8 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_8.jpg";
import coCurricularEvent_pro_conTech_2024_img_9 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_9.jpg";
import coCurricularEvent_pro_conTech_2024_img_10 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_10.jpg";
import coCurricularEvent_pro_conTech_2024_img_11 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_11.jpg";
import coCurricularEvent_pro_conTech_2024_img_12 from "../../assets/images/events/coCurricular/conference/pro-ConTech-2024/pro_conTech_2024_img_12.jpg";
// 2024-25
import renaissance_2024_img_1 from "../../assets/images/events/coCurricular/renaissance/2024/img_1.jpg";
import renaissance_2024_img_2 from "../../assets/images/events/coCurricular/renaissance/2024/img_2.jpg";
import renaissance_2024_img_3 from "../../assets/images/events/coCurricular/renaissance/2024/img_3.jpg";
import renaissance_2024_img_4 from "../../assets/images/events/coCurricular/renaissance/2024/img_4.jpg";
import renaissance_2024_img_5 from "../../assets/images/events/coCurricular/renaissance/2024/img_5.jpg";
import renaissance_2024_img_6 from "../../assets/images/events/coCurricular/renaissance/2024/img_6.jpg";
import renaissance_2024_img_7 from "../../assets/images/events/coCurricular/renaissance/2024/img_7.jpg";
import renaissance_2024_img_8 from "../../assets/images/events/coCurricular/renaissance/2024/img_8.jpg";
import renaissance_2024_img_9 from "../../assets/images/events/coCurricular/renaissance/2024/img_9.jpg";
import renaissance_2024_img_10 from "../../assets/images/events/coCurricular/renaissance/2024/img_10.jpg";
import renaissance_2024_img_11 from "../../assets/images/events/coCurricular/renaissance/2024/img_11.jpg";
import renaissance_2024_img_12 from "../../assets/images/events/coCurricular/renaissance/2024/img_12.jpg";
import renaissance_2024_img_13 from "../../assets/images/events/coCurricular/renaissance/2024/img_13.jpg";
import renaissance_2024_img_14 from "../../assets/images/events/coCurricular/renaissance/2024/img_14.jpg";
import renaissance_2024_img_15 from "../../assets/images/events/coCurricular/renaissance/2024/img_15.jpg";
import renaissance_2024_img_16 from "../../assets/images/events/coCurricular/renaissance/2024/img_16.jpg";
import renaissance_2024_img_17 from "../../assets/images/events/coCurricular/renaissance/2024/img_17.jpg";
import renaissance_2024_img_18 from "../../assets/images/events/coCurricular/renaissance/2024/img_18.jpg";
//Taping and its management in sports injuries
// import sportsInju1_2025 from "../../assets/images/events/coCurricular/Taping-and-Its-management-in-sports-injuries-2025/sports-injuries-1-2025.jpeg";
// import sportsInju2_2025 from "../../assets/images/events/coCurricular/Taping-and-Its-management-in-sports-injuries-2025/sports-injuries-2-2025.jpeg";
//Physio Badminton tournament 
import Badminton1_2025 from "../../assets/images/events/coCurricular/Physio-Badmnton-2025/Badminton12025.jpeg";
import Badminton2_2025 from "../../assets/images/events/coCurricular/Physio-Badmnton-2025/Badminton22025.jpeg";
import Badminton3_2025 from "../../assets/images/events/coCurricular/Physio-Badmnton-2025/Badminton32025.jpeg";
import Badminton4_2025 from "../../assets/images/events/coCurricular/Physio-Badmnton-2025/Badminton42025.jpeg";
import Badminton5_2025 from "../../assets/images/events/coCurricular/Physio-Badmnton-2025/Badminton52025.jpeg";
import Badminton6_2025 from "../../assets/images/events/coCurricular/Physio-Badmnton-2025/Badminton62025.jpeg";
//Women's Day
import WomenDay1_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay1.jpeg";
import WomenDay2_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay2.jpeg";
import WomenDay3_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay3.jpeg";
import WomenDay4_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay4.jpeg";
import WomenDay5_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay5.jpeg";
import WomenDay6_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay6.jpeg";
import WomenDay7_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay7.jpeg";
import WomenDay8_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay8.jpeg";
import WomenDay9_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay9.jpeg";
import WomenDay10_2025 from "../../assets/images/events/coCurricular/Women's-Day-2025/Women'sDay10.jpeg";


//2025-26
//Ashadi Palkhi Sohala
import palkhi1 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.19.44 PM.jpeg";
import palkhi2 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.19.45 PM.jpeg";
import palkhi3 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.03 PM.jpeg";
import palkhi4 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.04 PM (1).jpeg";
import palkhi5 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.05 PM (1).jpeg";
import palkhi6 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.05 PM.jpeg";
import palkhi7 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.06 PM (1).jpeg";
import palkhi8 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.06 PM.jpeg";
import palkhi9 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.07 PM (1).jpeg";
import palkhi10 from "../../assets/images/events/coCurricular/Ashadi_Palkhi_Sohala_Physiotherapy _Camp2025/WhatsApp Image 2025-06-21 at 1.20.07 PM.jpeg";

//antiRagging 2025
import ar1 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.10 PM.jpeg";
import ar2 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.11 PM (1).jpeg";
import ar3 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.11 PM.jpeg";
import ar4 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.38 PM (1).jpeg";
import ar5 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.38 PM.jpeg";
import ar6 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.40 PM.jpeg";
import ar7 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.41 PM (1).jpeg";
import ar8 from "../../assets/images/events/coCurricular/Anti-ragging 2025/WhatsApp Image 2025-08-28 at 7.11.41 PM.jpeg";

//GenderSensitizationEssayWritingCompetition
import GenderEssay1 from "../../assets/images/events/coCurricular/GenderSensitizationEssayWritingCompetition/WhatsApp Image 2025-08-26 at 4.29.36 PM.jpeg";
import GenderEssay2 from "../../assets/images/events/coCurricular/GenderSensitizationEssayWritingCompetition/WhatsApp Image 2025-08-26 at 4.29.37 PM (1).jpeg";
import GenderEssay3 from "../../assets/images/events/coCurricular/GenderSensitizationEssayWritingCompetition/WhatsApp Image 2025-08-26 at 4.29.37 PM.jpeg";
import GenderEssay4 from "../../assets/images/events/coCurricular/GenderSensitizationEssayWritingCompetition/WhatsApp Image 2025-08-26 at 4.29.38 PM.jpeg";

//PhysiotherapyCamp Rangri 2025
import PhysiotherapyCamp1 from "../../assets/images/events/coCurricular/PhysiotherapyCampRangari2025/WhatsApp Image 2025-09-03 at 5.03.49 PM (1).jpeg";
import PhysiotherapyCamp2 from "../../assets/images/events/coCurricular/PhysiotherapyCampRangari2025/WhatsApp Image 2025-09-03 at 5.03.49 PM.jpeg";
import PhysiotherapyCamp3 from "../../assets/images/events/coCurricular/PhysiotherapyCampRangari2025/WhatsApp Image 2025-09-03 at 5.04.40 PM.jpeg";

//PhysiotherapyCamp Dagdusheth 2025
import PhysiotherapyCamp_Dagdusheth1 from "../../assets/images/events/coCurricular/PhysiotherapyCampDagduSheth2025/WhatsApp Image 2025-08-29 at 4.17.50 PM (1).jpeg";
import PhysiotherapyCamp_Dagdusheth2 from "../../assets/images/events/coCurricular/PhysiotherapyCampDagduSheth2025/WhatsApp Image 2025-08-29 at 4.17.50 PM (2).jpeg";
import PhysiotherapyCamp_Dagdusheth3 from "../../assets/images/events/coCurricular/PhysiotherapyCampDagduSheth2025/WhatsApp Image 2025-08-29 at 4.17.50 PM.jpeg";
import PhysiotherapyCamp_Dagdusheth4 from "../../assets/images/events/coCurricular/PhysiotherapyCampDagduSheth2025/WhatsApp Image 2025-08-29 at 4.22.57 PM.jpeg";

//NationalSportsDay2025
import NationalSportsDay2025_1 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-29 at 2.19.13 PM.jpeg";
import NationalSportsDay2025_2 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-29 at 2.19.14 PM.jpeg";
import NationalSportsDay2025_3 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-29 at 2.19.15 PM.jpeg";
import NationalSportsDay2025_4 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-31 at 10.09.26 AM.jpeg";
import NationalSportsDay2025_5 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-31 at 10.09.27 AM.jpeg";
import NationalSportsDay2025_6 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-31 at 10.09.28 AM.jpeg";
import NationalSportsDay2025_7 from "../../assets/images/events/coCurricular/NationalSportsDay2025/WhatsApp Image 2025-08-31 at 10.09.29 AM.jpeg";

// Renaissance 2025
import renaissance2025_1 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0028 (1).jpg";
import renaissance2025_2 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0028.jpg";
import renaissance2025_3 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0371.jpg";
import renaissance2025_4 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0392.jpg";
import renaissance2025_5 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0449.jpg";
import renaissance2025_6 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0740.jpg";
import renaissance2025_7 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_0762.jpg";
import renaissance2025_8 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1003.jpg";
import renaissance2025_9 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1029.jpg";
import renaissance2025_10 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1125.jpg";
import renaissance2025_11 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1133.jpg";
import renaissance2025_12 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1160.jpg";
import renaissance2025_13 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1191.jpg";
import renaissance2025_14 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1199.jpg";
import renaissance2025_15 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1274.jpg";
import renaissance2025_16 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1377.jpg";
import renaissance2025_17 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1467 (1).jpg";
import renaissance2025_18 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1530.jpg";
import renaissance2025_19 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_1538.jpg";
import renaissance2025_20 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_2484.jpg";
import renaissance2025_21 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_2510.jpg";
import renaissance2025_22 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_2598.jpg";
import renaissance2025_23 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5195.jpg";
import renaissance2025_24 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5217.jpg";
import renaissance2025_25 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5227.jpg";
import renaissance2025_26 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5248.jpg";
import renaissance2025_27 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5254.jpg";
import renaissance2025_28 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5296.jpg";
import renaissance2025_29 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5322.jpg";
import renaissance2025_30 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5508.jpg";
import renaissance2025_31 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5640.jpg";
import renaissance2025_32 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5654.jpg";
import renaissance2025_33 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5662.jpg";
import renaissance2025_34 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5783.jpg";
import renaissance2025_35 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5798.jpg";
import renaissance2025_36 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5835.jpg";
import renaissance2025_37 from "../../assets/images/events/coCurricular/Renaissance-2025/IMG_5839.jpg";


// 2023-24
import renaissance_2023_24_img_1 from "../../assets/images/events/coCurricular/renaissance/2023/01.jpg";
import renaissance_2023_24_img_2 from "../../assets/images/events/coCurricular/renaissance/2023/02.jpg";
import renaissance_2023_24_img_3 from "../../assets/images/events/coCurricular/renaissance/2023/03.jpg";
import renaissance_2023_24_img_4 from "../../assets/images/events/coCurricular/renaissance/2023/04.jpg";
// 2022-23
import renaissance_2022_img_1 from "../../assets/images/events/coCurricular/renaissance/2022/img1.jpg";
import renaissance_2022_img_2 from "../../assets/images/events/coCurricular/renaissance/2022/img2.jpg";
import renaissance_2022_img_3 from "../../assets/images/events/coCurricular/renaissance/2022/img3.jpg";
import renaissance_2022_img_4 from "../../assets/images/events/coCurricular/renaissance/2022/img4.jpg";
import renaissance_2022_img_5 from "../../assets/images/events/coCurricular/renaissance/2022/img5.jpg";
import renaissance_2022_img_6 from "../../assets/images/events/coCurricular/renaissance/2022/img6.jpg";
import renaissance_2022_img_7 from "../../assets/images/events/coCurricular/renaissance/2022/img7.jpg";
import renaissance_2022_img_8 from "../../assets/images/events/coCurricular/renaissance/2022/img8.jpg";
import renaissance_2022_img_9 from "../../assets/images/events/coCurricular/renaissance/2022/img9.jpg";
import renaissance_2022_img_10 from "../../assets/images/events/coCurricular/renaissance/2022/img10.jpg";
import renaissance_2022_img_11 from "../../assets/images/events/coCurricular/renaissance/2022/img11.jpg";
import renaissance_2022_img_12 from "../../assets/images/events/coCurricular/renaissance/2022/img12.jpg";
import renaissance_2022_img_13 from "../../assets/images/events/coCurricular/renaissance/2022/img13.jpg";
import renaissance_2022_img_14 from "../../assets/images/events/coCurricular/renaissance/2022/img14.jpg";
import renaissance_2022_img_15 from "../../assets/images/events/coCurricular/renaissance/2022/img15.jpg";
// 2021-22 -- 2020
import renaissance_2021_22_img_1 from "../../assets/images/events/coCurricular/renaissance/2020/01.jpg";
import renaissance_2021_22_img_2 from "../../assets/images/events/coCurricular/renaissance/2020/02.jpg";
import renaissance_2021_22_img_3 from "../../assets/images/events/coCurricular/renaissance/2020/03.jpg";
import renaissance_2021_22_img_4 from "../../assets/images/events/coCurricular/renaissance/2020/04.jpg";
import renaissance_2021_22_img_5 from "../../assets/images/events/coCurricular/renaissance/2020/05.jpg";
// 2019-20
import renaissance_2019_20_img_1 from "../../assets/images/events/coCurricular/renaissance/2019/01.jpg";
import renaissance_2019_20_img_2 from "../../assets/images/events/coCurricular/renaissance/2019/02.jpg";
import renaissance_2019_20_img_3 from "../../assets/images/events/coCurricular/renaissance/2019/03.jpg";
import renaissance_2019_20_img_4 from "../../assets/images/events/coCurricular/renaissance/2019/04.jpg";
import renaissance_2019_20_img_5 from "../../assets/images/events/coCurricular/renaissance/2019/05.jpg";
// sports
import sports_img_1 from "../../assets/images/gallery/sports/img1.jpg";
import sports_img_2 from "../../assets/images/gallery/sports/img2.jpg";
import sports_img_3 from "../../assets/images/gallery/sports/img3.jpg";
import sports_img_4 from "../../assets/images/gallery/sports/img4.jpg";
import sports_img_5 from "../../assets/images/gallery/sports/img5.jpg";

//2026
//Hockey West Zone Inter University Girls (Dec 2025)
import hockey1 from "../../assets/images/events/coCurricular/HockeyWestZoneInterUniversityGirls/20251227_32257PMByGPSMapCamera.jpg";
import hockey2 from "../../assets/images/events/coCurricular/HockeyWestZoneInterUniversityGirls/20251227_32506PMByGPSMapCamera.jpg";
import hockey3 from "../../assets/images/events/coCurricular/HockeyWestZoneInterUniversityGirls/IMG-20260105-WA0008.jpg";
import hockey4 from "../../assets/images/events/coCurricular/HockeyWestZoneInterUniversityGirls/IMG-20260105-WA0013.jpg";
import hockey5 from "../../assets/images/events/coCurricular/HockeyWestZoneInterUniversityGirls/IMG-20260105-WA0017.jpg";

//GUEST LECTURE ON BHAGWAT GITA TEACHINGS (21-11-2025)
import guestLecture1 from "../../assets/images/events/coCurricular/GuestlectureonBhagwatGitaTeachings/WhatsApp Image 2026-01-30 at 11.08.51 AM (6).jpeg";
import guestLecture2 from "../../assets/images/events/coCurricular/GuestlectureonBhagwatGitaTeachings/WhatsApp Image 2026-01-30 at 11.08.51 AM (7).jpeg";
import guestLecture3 from "../../assets/images/events/coCurricular/GuestlectureonBhagwatGitaTeachings/WhatsApp Image 2026-01-30 at 11.08.51 AM (8).jpeg";
import guestLecture4 from "../../assets/images/events/coCurricular/GuestlectureonBhagwatGitaTeachings/WhatsApp Image 2026-01-30 at 11.08.52 AM (1).jpeg";
import guestLecture5 from "../../assets/images/events/coCurricular/GuestlectureonBhagwatGitaTeachings/WhatsApp Image 2026-01-30 at 11.08.52 AM.jpeg";

//AWARENESS OF HPV VACCINATION
import HPV1 from "../../assets/images/events/coCurricular/AwarenessofHPVvacciniation/WhatsApp Image 2026-01-30 at 11.08.51 AM (1).jpeg";
import HPV2 from "../../assets/images/events/coCurricular/AwarenessofHPVvacciniation/WhatsApp Image 2026-01-30 at 11.08.51 AM (2).jpeg";
import HPV3 from "../../assets/images/events/coCurricular/AwarenessofHPVvacciniation/WhatsApp Image 2026-01-30 at 11.08.51 AM (3).jpeg";
import HPV4 from "../../assets/images/events/coCurricular/AwarenessofHPVvacciniation/WhatsApp Image 2026-01-30 at 11.08.51 AM (4).jpeg";
import HPV5 from "../../assets/images/events/coCurricular/AwarenessofHPVvacciniation/WhatsApp Image 2026-01-30 at 11.08.51 AM (5).jpeg";
import HPV6 from "../../assets/images/events/coCurricular/AwarenessofHPVvacciniation/WhatsApp Image 2026-01-30 at 11.08.51 AM.jpeg";

//Nasha Mukti Awareness Drive
import NMA1 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-24 at 11.55.35 AM (1).jpeg";
import NMA2 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-24 at 11.55.35 AM.jpeg";
import NMA3 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-24 at 11.55.36 AM.jpeg";
import NMA4 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-24 at 11.56.17 AM.jpeg";
import NMA5 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-24 at 11.56.57 AM.jpeg";
import NMA6 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-24 at 11.58.15 AM.jpeg";
import NMA7 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-25 at 10.06.24 AM (1).jpeg";
import NMA8 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-25 at 10.06.24 AM (2).jpeg";
import NMA9 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-25 at 10.06.24 AM.jpeg";
import NMA10 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-25 at 10.07.33 AM (1).jpeg";
import NMA11 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-25 at 10.07.33 AM.jpeg";
import NMA12 from "../../assets/images/events/coCurricular/NashaMuktiAwarenessdrive2026/WhatsApp Image 2026-02-25 at 10.07.34 AM.jpeg";

//Free physiotherapy Camp at PES Modern College of Arts, Commerce & Science, Shivaji Nagar, Pune -5 DATE: 10-03-2026
import Camp1 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.18 AM (1).jpeg";
import Camp2 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.18 AM.jpeg";
import Camp3 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.19 AM (1).jpeg";
import Camp4 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.19 AM (2).jpeg";
import Camp5 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.19 AM.jpeg";
import Camp6 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.20 AM.jpeg";
import Camp7 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.21 AM (1).jpeg";
import Camp8 from "../../assets/images/events/coCurricular/FreePhysiotherapyCampatShivajiNagar/WhatsApp Image 2026-03-12 at 11.57.21 AM.jpeg";


//Obesity Assessment Camp  at Kunjirwadi and Loni Kalbhor PHCat on 10 th March
import ObesityCamp1 from "../../assets/images/events/coCurricular/ObesityAssessmentCampKunjirwadiLoniKalbhorPHC/WhatsApp Image 2026-03-11 at 11.30.36 AM (1).jpeg";
import ObesityCamp2 from "../../assets/images/events/coCurricular/ObesityAssessmentCampKunjirwadiLoniKalbhorPHC/WhatsApp Image 2026-03-11 at 11.30.36 AM.jpeg";
import ObesityCamp3 from "../../assets/images/events/coCurricular/ObesityAssessmentCampKunjirwadiLoniKalbhorPHC/WhatsApp Image 2026-03-11 at 11.30.37 AM (1).jpeg";
import ObesityCamp4 from "../../assets/images/events/coCurricular/ObesityAssessmentCampKunjirwadiLoniKalbhorPHC/WhatsApp Image 2026-03-11 at 11.30.37 AM (2).jpeg";
import ObesityCamp5 from "../../assets/images/events/coCurricular/ObesityAssessmentCampKunjirwadiLoniKalbhorPHC/WhatsApp Image 2026-03-11 at 11.30.37 AM.jpeg";


//RENAISSANCE2026
import renaissance20261 from "../../assets/images/events/coCurricular/RENAISSANCE2026/WhatsApp Image 2026-04-08 at 2.33.57 PM.jpeg";
import renaissance20262 from "../../assets/images/events/coCurricular/RENAISSANCE2026/WhatsApp Image 2026-04-08 at 2.46.11 PM.jpeg";
import renaissance20263 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0241.jpeg";
import renaissance20264 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0094.jpeg";
import renaissance20265 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0125.jpeg";
import renaissance20266 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0501.jpeg";
import renaissance20267 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0515 (1).jpeg";
import renaissance20268 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0744.jpeg";
import renaissance20269 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0836.jpeg";
import renaissance202610 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_0840.jpeg";
import renaissance202611 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_1344.jpeg";
import renaissance202612 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_1369.jpeg";
import renaissance202613 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_1520.jpeg";
import renaissance202614 from "../../assets/images/events/coCurricular/RENAISSANCE2026/IMG_1530 (1).jpeg";

//UGAM2026
import UGAM20261 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0012.jpeg";
import UGAM20262 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0016.jpeg";
import UGAM20263 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0030 copy.jpeg";
import UGAM20264 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0038.jpeg";
import UGAM20265 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0042.jpeg";
import UGAM20266 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0049.jpeg";
import UGAM20267 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0053.jpeg";
import UGAM20268 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0103.jpeg";
import UGAM20269 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0109.jpeg";
import UGAM202610 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0111.jpeg";
import UGAM202611 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0123.jpeg";
import UGAM202612 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0134.jpeg";
import UGAM202613 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0142.jpeg";
import UGAM202614 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0154.jpeg";
import UGAM202615 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0173.jpeg";
import UGAM202616 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0180.jpeg";
import UGAM202617 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0196.jpeg";
import UGAM202618 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0223 (1).jpeg";
import UGAM202619 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0223.jpeg";
import UGAM202620 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0234.jpeg";
import UGAM202621 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0247.jpeg";
import UGAM202622 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0251.jpeg";
import UGAM202623 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0260.jpeg";
import UGAM202624 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0269.jpeg";
import UGAM202625 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0275.jpeg";
import UGAM202626 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0282.jpeg";
import UGAM202627 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0290.jpeg";
import UGAM202628 from "../../assets/images/events/coCurricular/UGAM2026/DSC_9990.jpeg";
import UGAM202629 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0313.jpeg";
import UGAM202630 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0329.jpeg";
import UGAM202631 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0359.jpeg";
import UGAM202632 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0382.jpeg";
import UGAM202633 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0407.jpeg";
import UGAM202634 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0464.jpeg";
import UGAM202635 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0531.jpeg";
import UGAM202636 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0536.jpeg";
import UGAM202637 from "../../assets/images/events/coCurricular/UGAM2026/DSC_0572.jpeg";
import UGAM202638 from "../../assets/images/events/coCurricular/UGAM2026/DSC_9928.jpeg";
import UGAM202639 from "../../assets/images/events/coCurricular/UGAM2026/DSC_9936.jpeg";
import UGAM202640 from "../../assets/images/events/coCurricular/UGAM2026/DSC_9948.jpeg";
import UGAM202641 from "../../assets/images/events/coCurricular/UGAM2026/DSC_9989 copy.jpeg";


import yoga1 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-19 at 1.16.43 PM (1).jpeg";
import yoga2 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-19 at 1.16.43 PM.jpeg";
import yoga3 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-19 at 1.16.44 PM.jpeg";
import yoga4 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-19 at 1.17.05 PM (1).jpeg";
import yoga5 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-19 at 1.17.05 PM.jpeg";
import yoga6 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-27 at 12.05.08 PM.jpeg";
import yoga7 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-27 at 12.05.10 PM.jpeg";
import yoga8 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-27 at 12.05.11 PM.jpeg";
import yoga9 from "../../assets/images/events/coCurricular/InternationalYogaDay/WhatsApp Image 2026-06-27 at 12.05.12 PM.jpeg";

import a1 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.19 PM (1).jpeg";
import a2 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.19 PM.jpeg";
import a3 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.20 PM (1).jpeg";
import a4 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.20 PM (2).jpeg";
import a5 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.20 PM (3).jpeg";
import a6 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.20 PM.jpeg";
import a7 from "../../assets/images/events/coCurricular/AshadiVariDisabilityAssessmentTreatmentCamp2026/WhatsApp Image 2026-07-09 at 2.52.21 PM.jpeg";

import ap1 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.19 PM (1).jpeg";
import ap2 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.19 PM.jpeg";
import ap3 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.20 PM (1).jpeg";
import ap4 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.20 PM.jpeg";
import ap5 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.21 PM (1).jpeg";
import ap6 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.21 PM.jpeg";
import ap7 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.22 PM (1).jpeg";
import ap8 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.25.22 PM.jpeg";
import ap9 from "../../assets/images/events/coCurricular/AshadiVariPalkhiSohalaPhysiotherapyCamp/WhatsApp Image 2026-07-09 at 9.32.51 PM.jpeg";

//ANTI-RAGGING WEEK
import antiRaggingWeek1 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.10 PM.jpeg";
import antiRaggingWeek2 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.11 PM (1).jpeg";
import antiRaggingWeek3 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.11 PM.jpeg";
import antiRaggingWeek4 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.38 PM (1).jpeg";
import antiRaggingWeek5 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.38 PM.jpeg";
import antiRaggingWeek6 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.40 PM.jpeg";
import antiRaggingWeek7 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.41 PM (1).jpeg";
import antiRaggingWeek8 from "../../assets/images/events/coCurricular/ANTIRAGGINGWEEK2026/WhatsApp Image 2025-08-28 at 7.11.41 PM.jpeg";

//Gender Equity Day 2026,
import genderEquityDay2026_1 from "../../assets/images/events/coCurricular/GenderEquityDay2026/WhatsApp Image 2026-09-21 at 12.00.11 PM (1).jpeg";
import genderEquityDay2026_2 from "../../assets/images/events/coCurricular/GenderEquityDay2026/WhatsApp Image 2026-09-21 at 12.00.11 PM.jpeg";
import genderEquityDay2026_3 from "../../assets/images/events/coCurricular/GenderEquityDay2026/WhatsApp Image 2026-09-21 at 12.00.12 PM.jpeg";
import genderEquityDay2026_4 from "../../assets/images/events/coCurricular/GenderEquityDay2026/WhatsApp Image 2026-09-21 at 12.00.13 PM.jpeg";

// Camp with Shrimant Dagduseth Trust, Pune 21-09-2026
import campWithShrimantDagdusethTrust1 from "../../assets/images/events/coCurricular/CampwithShrimantDagdusethGanpatiTrust2026/WhatsApp Image 2026-10-12 at 11.01.51 AM.jpeg";
import campWithShrimantDagdusethTrust2 from "../../assets/images/events/coCurricular/CampwithShrimantDagdusethGanpatiTrust2026/WhatsApp Image 2026-10-12 at 11.01.52 AM.jpeg";
import campWithShrimantDagdusethTrust3 from "../../assets/images/events/coCurricular/CampwithShrimantDagdusethGanpatiTrust2026/WhatsApp Image 2026-10-12 at 11.01.59 AM (1).jpeg";
import campWithShrimantDagdusethTrust4 from "../../assets/images/events/coCurricular/CampwithShrimantDagdusethGanpatiTrust2026/WhatsApp Image 2026-10-12 at 11.01.59 AM.jpeg";

// Camp with Shrimant Bahurangari Ganpati Mandal, Pune 22-09-2026.
import campWithShrimantBahurangariGanpatiMandal1 from "../../assets/images/events/coCurricular/CampwithShrimantBahurangariGanpatiMandal2026/WhatsApp Image 2026-09-23 at 10.52.06 AM.jpeg";
import campWithShrimantBahurangariGanpatiMandal2 from "../../assets/images/events/coCurricular/CampwithShrimantBahurangariGanpatiMandal2026/WhatsApp Image 2026-09-23 at 10.52.09 AM.jpeg";
import campWithShrimantBahurangariGanpatiMandal3 from "../../assets/images/events/coCurricular/CampwithShrimantBahurangariGanpatiMandal2026/WhatsApp Image 2026-09-23 at 10.52.10 AM.jpeg";
import campWithShrimantBahurangariGanpatiMandal4 from "../../assets/images/events/coCurricular/CampwithShrimantBahurangariGanpatiMandal2026/WhatsApp Image 2026-09-23 at 10.52.11 AM.jpeg";
import campWithShrimantBahurangariGanpatiMandal5 from "../../assets/images/events/coCurricular/CampwithShrimantBahurangariGanpatiMandal2026/WhatsApp Image 2026-09-23 at 10.52.19 AM.jpeg";

//Non-Violence Week 2026, 29-09-26 to 05-10-26
import nonViolenceWeek2026_1 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-01 at 1.05.20 PM.jpeg";
import nonViolenceWeek2026_2 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-01 at 1.05.21 PM.jpeg";
import nonViolenceWeek2026_3 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-01 at 1.05.22 PM (1).jpeg";
import nonViolenceWeek2026_4 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-01 at 1.05.22 PM.jpeg";
import nonViolenceWeek2026_5 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.41.11 PM.jpeg";
import nonViolenceWeek2026_6 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.41.18 PM.jpeg";
import nonViolenceWeek2026_7 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.41.19 PM.jpeg";
import nonViolenceWeek2026_8 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.42.00 PM.jpeg";
import nonViolenceWeek2026_9 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.42.06 PM.jpeg";
import nonViolenceWeek2026_10 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.45.53 PM.jpeg";
import nonViolenceWeek2026_11 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.45.55 PM.jpeg";
import nonViolenceWeek2026_12 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.45.56 PM (1).jpeg";
import nonViolenceWeek2026_13 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.45.56 PM.jpeg";
import nonViolenceWeek2026_14 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-03 at 12.45.57 PM.jpeg";
import nonViolenceWeek2026_15 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-12 at 11.28.47 AM (1).jpeg";
import nonViolenceWeek2026_16 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-12 at 11.28.47 AM.jpeg";
import nonViolenceWeek2026_17 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-12 at 11.28.48 AM.jpeg";
import nonViolenceWeek2026_18 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-12 at 11.29.35 AM (1).jpeg";
import nonViolenceWeek2026_19 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-12 at 11.29.35 AM (2).jpeg";
import nonViolenceWeek2026_20 from "../../assets/images/events/coCurricular/Non_ViolenceWeek2026/WhatsApp Image 2026-10-12 at 11.29.35 AM.jpeg";


// swachh bharat divas, 03-10-2026
import swachhBharatDivas1 from "../../assets/images/events/coCurricular/SwachhBharatdivas2026/WhatsApp Image 2026-10-12 at 11.32.18 AM (1).jpeg";
import swachhBharatDivas2 from "../../assets/images/events/coCurricular/SwachhBharatdivas2026/WhatsApp Image 2026-10-12 at 11.32.18 AM.jpeg";
import swachhBharatDivas3 from "../../assets/images/events/coCurricular/SwachhBharatdivas2026/WhatsApp Image 2026-10-12 at 11.32.19 AM (1).jpeg";
import swachhBharatDivas4 from "../../assets/images/events/coCurricular/SwachhBharatdivas2026/WhatsApp Image 2026-10-12 at 11.32.19 AM.jpeg";
import swachhBharatDivas5 from "../../assets/images/events/coCurricular/SwachhBharatdivas2026/WhatsApp Image 2026-10-12 at 11.32.20 AM.jpeg";



type Years = Array<DataItem>;

type DataItem = {
  year: string;
  data: Array<CocoCurricularEventObject>;
};

type EventsProps = {
  data: Array<CocoCurricularEventObject>;
};

type ImageType = {
  src: string;
  alt: string;
};

type CocoCurricularEventObject = {
  title: string;
  description?: string;
  img?: Array<ImageType>;
};


const coCurricularEventsData_2025_26: Array<CocoCurricularEventObject> = [
       {
    title: "Swachh Bharat Divas, 03-10-2026",
    img: [
      { src: swachhBharatDivas1, alt: "swachhBharatDivas1" },
      { src: swachhBharatDivas2, alt: "swachhBharatDivas2" },
      { src: swachhBharatDivas3, alt: "swachhBharatDivas3" },
      { src: swachhBharatDivas4, alt: "swachhBharatDivas4" },
      { src: swachhBharatDivas5, alt: "swachhBharatDivas5" },
    ]
  },
     {
    title: "Non-Violence Week 2026, 29-09-26 to 05-10-26",
    img: [
      { src: nonViolenceWeek2026_1, alt: "nonViolenceWeek2026_1" },
      { src: nonViolenceWeek2026_2, alt: "nonViolenceWeek2026_2" },
      { src: nonViolenceWeek2026_3, alt: "nonViolenceWeek2026_3" },
      { src: nonViolenceWeek2026_4, alt: "nonViolenceWeek2026_4" },
      { src: nonViolenceWeek2026_5, alt: "nonViolenceWeek2026_5" },
      { src: nonViolenceWeek2026_6, alt: "nonViolenceWeek2026_6" }, 
      { src: nonViolenceWeek2026_7, alt: "nonViolenceWeek2026_7" },
      { src: nonViolenceWeek2026_8, alt: "nonViolenceWeek2026_8" },
      { src: nonViolenceWeek2026_9, alt: "nonViolenceWeek2026_9" },
      { src: nonViolenceWeek2026_10, alt: "nonViolenceWeek2026_10" },
      { src: nonViolenceWeek2026_11, alt: "nonViolenceWeek2026_11" },
      { src: nonViolenceWeek2026_12, alt: "nonViolenceWeek2026_12" },
      { src: nonViolenceWeek2026_13, alt: "nonViolenceWeek2026_13" },
      { src: nonViolenceWeek2026_14, alt: "nonViolenceWeek2026_14" },
      { src: nonViolenceWeek2026_15, alt: "nonViolenceWeek2026_15" },
      { src: nonViolenceWeek2026_16, alt: "nonViolenceWeek2026_16" },
      { src: nonViolenceWeek2026_17, alt: "nonViolenceWeek2026_17" },
      { src: nonViolenceWeek2026_18, alt: "nonViolenceWeek2026_18" },
      { src: nonViolenceWeek2026_19, alt: "nonViolenceWeek2026_19" },
      { src: nonViolenceWeek2026_20, alt: "nonViolenceWeek2026_20" },
    ]
  },
     {
    title: "Camp with Shrimant Bahurangari Ganpati Mandal, Pune 22-09-2026.",
    img: [
      { src: campWithShrimantBahurangariGanpatiMandal1, alt: "campWithShrimantBahurangariGanpatiMandal1" },
      { src: campWithShrimantBahurangariGanpatiMandal2, alt: "campWithShrimantBahurangariGanpatiMandal2" },
      { src: campWithShrimantBahurangariGanpatiMandal3, alt: "campWithShrimantBahurangariGanpatiMandal3" },
      { src: campWithShrimantBahurangariGanpatiMandal4, alt: "campWithShrimantBahurangariGanpatiMandal4" },
      { src: campWithShrimantBahurangariGanpatiMandal5, alt: "campWithShrimantBahurangariGanpatiMandal5" },
    ]
  },
   {
    title: "Camp with Shrimant Dagduseth Trust, Pune 21-09-2026",
    img: [
      { src: campWithShrimantDagdusethTrust1, alt: "campWithShrimantDagdusethTrust1" },
      { src: campWithShrimantDagdusethTrust2, alt: "campWithShrimantDagdusethTrust2" },
      { src: campWithShrimantDagdusethTrust3, alt: "campWithShrimantDagdusethTrust3" },
      { src: campWithShrimantDagdusethTrust4, alt: "campWithShrimantDagdusethTrust4" },
    ]
  },
  {
    title: "Gender Equity Day 2026",
    img: [
      { src: genderEquityDay2026_1, alt: "genderEquityDay2026_1" },
      { src: genderEquityDay2026_2, alt: "genderEquityDay2026_2" },
      { src: genderEquityDay2026_3, alt: "genderEquityDay2026_3" },
      { src: genderEquityDay2026_4, alt: "genderEquityDay2026_4" },
    ]
  },
  {
    title: "ANTI-RAGGING WEEK 2026",
    img: [
      { src: antiRaggingWeek1, alt: "antiRaggingWeek1" },
      { src: antiRaggingWeek2, alt: "antiRaggingWeek2" },
      { src: antiRaggingWeek3, alt: "antiRaggingWeek3" },
      { src: antiRaggingWeek4, alt: "antiRaggingWeek4" },
      { src: antiRaggingWeek5, alt: "antiRaggingWeek5" },
      { src: antiRaggingWeek6, alt: "antiRaggingWeek6" },
      { src: antiRaggingWeek7, alt: "antiRaggingWeek7" },
      { src: antiRaggingWeek8, alt: "antiRaggingWeek8" },
    ]
  },
  {
    title: "PES MCOP with Physiosity and Sakal Yin : Ashadi Vari Physiotherapy Camp ",
    img: [
      { src: ap1, alt: "img" },
      { src: ap2, alt: "img" },
      { src: ap3, alt: "img" },
      { src: ap4, alt: "img" },
      { src: ap5, alt: "img" },
      { src: ap6, alt: "img" },
      { src: ap7, alt: "img" },
      { src: ap8, alt: "img" },
      { src: ap9, alt: "img" },
    ]
  },
  {
    title: "PES MCOP with Physiosity and Sakal Yin : Ashadi Vari Physiotherapy Camp ",
    img: [
      { src: ap1, alt: "img" },
      { src: ap2, alt: "img" },
      { src: ap3, alt: "img" },
      { src: ap4, alt: "img" },
      { src: ap5, alt: "img" },
      { src: ap6, alt: "img" },
      { src: ap7, alt: "img" },
      { src: ap8, alt: "img" },
      { src: ap9, alt: "img" },
    ]
  },
  {
    title: "PES MCOP with REABLE Foundation : Ashadi Wari Disability Assessment And Treatment Camp 2026",
    img: [
      { src: a1, alt: "img" },
      { src: a2, alt: "img" },
      { src: a3, alt: "img" },
      { src: a4, alt: "img" },
      { src: a5, alt: "img" },
      { src: a6, alt: "img" },
      { src: a7, alt: "img" },
    ]
  },
  {
    title: " International Yoga Day (19-06-2026)",
    img: [
      { src: yoga1, alt: "img" },
      { src: yoga2, alt: "img" },
      { src: yoga3, alt: "img" },
      { src: yoga4, alt: "img" },
      { src: yoga5, alt: "img" },
      { src: yoga6, alt: "img" },
      { src: yoga7, alt: "img" },
      { src: yoga8, alt: "img" },
      { src: yoga9, alt: "img" },
    ]
  },
  {
    title: "UGAM 2026 (26-03-2026)",
    img: [
      { src: UGAM20261, alt: "img" },
      { src: UGAM20262, alt: "img" },
      { src: UGAM20263, alt: "img" },
      { src: UGAM20264, alt: "img" },
      { src: UGAM20265, alt: "img" },
      { src: UGAM20266, alt: "img" },
      { src: UGAM20267, alt: "img" },
      { src: UGAM20268, alt: "img" },
      { src: UGAM20269, alt: "img" },
      { src: UGAM202610, alt: "img" },
      { src: UGAM202611, alt: "img" },
      { src: UGAM202612, alt: "img" },
      { src: UGAM202613, alt: "img" },
      { src: UGAM202614, alt: "img" },
      { src: UGAM202615, alt: "img" },
      { src: UGAM202616, alt: "img" },
      { src: UGAM202617, alt: "img" },
      { src: UGAM202618, alt: "img" },
      { src: UGAM202619, alt: "img" },
      { src: UGAM202620, alt: "img" },
      { src: UGAM202621, alt: "img" },
      { src: UGAM202622, alt: "img" },
      { src: UGAM202623, alt: "img" },
      { src: UGAM202624, alt: "img" },
      { src: UGAM202625, alt: "img" },
      { src: UGAM202626, alt: "img" },
      { src: UGAM202627, alt: "img" },
      { src: UGAM202628, alt: "img" },
      { src: UGAM202629, alt: "img" },
      { src: UGAM202630, alt: "img" },
      { src: UGAM202631, alt: "img" },
      { src: UGAM202632, alt: "img" },
      { src: UGAM202633, alt: "img" },
      { src: UGAM202634, alt: "img" },
      { src: UGAM202635, alt: "img" },
      { src: UGAM202636, alt: "img" },
      { src: UGAM202637, alt: "img" },
      { src: UGAM202638, alt: "img" },
      { src: UGAM202639, alt: "img" },
      { src: UGAM202640, alt: "img" },
      { src: UGAM202641, alt: "img" },
    ]
  },
  {
    title: "Renaissance 2026",
    img: [
      { src: renaissance20261, alt: "img" },
      { src: renaissance20262, alt: "img" },
      { src: renaissance20263, alt: "img" },
      { src: renaissance20264, alt: "img" },
      { src: renaissance20265, alt: "img" },
      { src: renaissance20266, alt: "img" },
      { src: renaissance20267, alt: "img" },
      { src: renaissance20268, alt: "img" },
      { src: renaissance20269, alt: "img" },
      { src: renaissance202610, alt: "img" },
      { src: renaissance202611, alt: "img" },
      { src: renaissance202612, alt: "img" },
      { src: renaissance202613, alt: "img" },
      { src: renaissance202614, alt: "img" },
    ]
  },
  {
    title: "Obesity Assessment Camp at Kunjirwadi and Loni Kalbhor PHC (10-03-2026)",
    img: [
      { src: ObesityCamp1, alt: "img" },
      { src: ObesityCamp2, alt: "img" },
      { src: ObesityCamp3, alt: "img" },
      { src: ObesityCamp4, alt: "img" },
      { src: ObesityCamp5, alt: "img" },
    ]
  },
  {
    title: "Free Physiotherapy Camp at PES Modern College of Arts, Commerce & Science, Shivaji Nagar, Pune (10-03-2026)",
    img: [
      { src: Camp1, alt: "img" },
      { src: Camp2, alt: "img" },
      { src: Camp3, alt: "img" },
      { src: Camp4, alt: "img" },
      { src: Camp5, alt: "img" },
      { src: Camp6, alt: "img" },
      { src: Camp7, alt: "img" },
      { src: Camp8, alt: "img" },
    ]
  },
  {
    title: "Nasha Mukti Awareness Drive (24-02-2026)",
    img: [
      { src: NMA1, alt: "img" },
      { src: NMA2, alt: "img" },
      { src: NMA3, alt: "img" },
      { src: NMA4, alt: "img" },
      { src: NMA5, alt: "img" },
      { src: NMA6, alt: "img" },
      { src: NMA7, alt: "img" },
      { src: NMA8, alt: "img" },
      { src: NMA9, alt: "img" },
      { src: NMA10, alt: "img" },
      { src: NMA11, alt: "img" },
      { src: NMA12, alt: "img" },
    ]
  },
  {
    title: "AWARENESS OF HPV VACCINATION (21-11-2025)",
    img: [
      { src: HPV1, alt: "img" },
      { src: HPV2, alt: "img" },
      { src: HPV3, alt: "img" },
      { src: HPV4, alt: "img" },
      { src: HPV5, alt: "img" },
      { src: HPV6, alt: "img" },
    ]
  },
  {
    title: "GUEST LECTURE ON BHAGWAT GITA TEACHINGS (21-11-2025)",
    img: [
      { src: guestLecture1, alt: "img" },
      { src: guestLecture2, alt: "img" },
      { src: guestLecture3, alt: "img" },
      { src: guestLecture4, alt: "img" },
      { src: guestLecture5, alt: "img" },
    ]
  },
  {
    title: "Hockey West Zone Inter University Girls (Dec 2025)",
    img: [
      { src: hockey1, alt: "img" },
      { src: hockey2, alt: "img" },
      { src: hockey3, alt: "img" },
      { src: hockey4, alt: "img" },
      { src: hockey5, alt: "img" },
    ]
  },
  {
    title: "Free Physiotherapy camp at Shrimant Bhau Rangari Ganpati trust: 03-09-2025",
    img: [
      { src: PhysiotherapyCamp1, alt: "img" },
      { src: PhysiotherapyCamp2, alt: "img" },
      { src: PhysiotherapyCamp3, alt: "img" },
    ]
  },
  {
    title: "Free Physiotherapy camp at Shrimant Dagduseth Ganpati trust: 29-08-2025 & 30-08-2025",
    img: [
      { src: PhysiotherapyCamp_Dagdusheth1, alt: "img" },
      { src: PhysiotherapyCamp_Dagdusheth2, alt: "img" },
      { src: PhysiotherapyCamp_Dagdusheth3, alt: "img" },
      { src: PhysiotherapyCamp_Dagdusheth4, alt: "img" },
    ]
  },
  {
    title: "National Sports Day: Basket ball competition & Fitness challenge:29-08-2025 & 30-08-2025",
    img: [
      { src: NationalSportsDay2025_1, alt: "img" },
      { src: NationalSportsDay2025_2, alt: "img" },
      { src: NationalSportsDay2025_3, alt: "img" },
      { src: NationalSportsDay2025_4, alt: "img" },
      { src: NationalSportsDay2025_5, alt: "img" },
      { src: NationalSportsDay2025_6, alt: "img" },
      { src: NationalSportsDay2025_7, alt: "img" },
    ]
  },
  {
    title: "Gender Equity day: Essay Writing competition",
    img: [
      { src: GenderEssay1, alt: "img" },
      { src: GenderEssay2, alt: "img" },
      { src: GenderEssay3, alt: "img" },
      { src: GenderEssay4, alt: "img" }
    ]
  },
  {
    title: "Anti-ragging week: 12-08-2025 to 18-08-2025",
    img: [
      { src: ar1, alt: "img" },
      { src: ar2, alt: "img" },
      { src: ar3, alt: "img" },
      { src: ar4, alt: "img" },
      { src: ar5, alt: "img" },
      { src: ar6, alt: "img" },
      { src: ar7, alt: "img" },
      { src: ar8, alt: "img" }
    ]
  },
  {
    title: "Ashadi Palkhi Sohala - Physiotherapy Camp",
    img: [
      { src: palkhi1, alt: "palkhi1" },
      { src: palkhi2, alt: "palkhi2" },
      { src: palkhi3, alt: "palkhi3" },
      { src: palkhi4, alt: "palkhi4" },
      { src: palkhi5, alt: "palkhi5" },
      { src: palkhi6, alt: "palkhi6" },
      { src: palkhi7, alt: "palkhi7" },
      { src: palkhi8, alt: "palkhi8" },
      { src: palkhi9, alt: "palkhi9" },
      { src: palkhi10, alt: "palkhi10" }
    ]
  },
  {
    title: "RENAISSANCE 2025",
    img: [
      { src: renaissance2025_1, alt: "img1" },
      { src: renaissance2025_2, alt: "img1" },
      { src: renaissance2025_3, alt: "img1" },
      { src: renaissance2025_4, alt: "img1" },
      { src: renaissance2025_5, alt: "img1" },
      { src: renaissance2025_6, alt: "img1" },
      { src: renaissance2025_7, alt: "img1" },
      { src: renaissance2025_8, alt: "img1" },
      { src: renaissance2025_9, alt: "img1" },
      { src: renaissance2025_10, alt: "img1" },
      { src: renaissance2025_11, alt: "img1" },
      { src: renaissance2025_12, alt: "img1" },
      { src: renaissance2025_13, alt: "img1" },
      { src: renaissance2025_14, alt: "img1" },
      { src: renaissance2025_15, alt: "img1" },
      { src: renaissance2025_16, alt: "img1" },
      { src: renaissance2025_17, alt: "img1" },
      { src: renaissance2025_18, alt: "img1" },
      { src: renaissance2025_19, alt: "img1" },
      { src: renaissance2025_20, alt: "img1" },
      { src: renaissance2025_21, alt: "img1" },
      { src: renaissance2025_22, alt: "img1" },
      { src: renaissance2025_23, alt: "img1" },
      { src: renaissance2025_24, alt: "img1" },
      { src: renaissance2025_25, alt: "img1" },
      { src: renaissance2025_26, alt: "img1" },
      { src: renaissance2025_27, alt: "img1" },
      { src: renaissance2025_28, alt: "img1" },
      { src: renaissance2025_29, alt: "img1" },
      { src: renaissance2025_30, alt: "img1" },
      { src: renaissance2025_31, alt: "img1" },
      { src: renaissance2025_32, alt: "img1" },
      { src: renaissance2025_33, alt: "img1" },
      { src: renaissance2025_34, alt: "img1" },
      { src: renaissance2025_35, alt: "img1" },
      { src: renaissance2025_36, alt: "img1" },
      { src: renaissance2025_37, alt: "img1" },
    ]
  },
];

const coCurricularEventsData_2024_25: Array<CocoCurricularEventObject> = [

  {
    title: "International Women's Day - 2025",
    img: [
      { src: WomenDay1_2025, alt: "WomenDay1_2025" },
      { src: WomenDay2_2025, alt: "WomenDay2_2025" },
      { src: WomenDay3_2025, alt: "WomenDay3_2025" },
      { src: WomenDay4_2025, alt: "WomenDay4_2025" },
      { src: WomenDay5_2025, alt: "WomenDay5_2025" },
      { src: WomenDay6_2025, alt: "WomenDay6_2025" },
      { src: WomenDay7_2025, alt: "WomenDay7_2025" },
      { src: WomenDay8_2025, alt: "WomenDay8_2025" },
      { src: WomenDay9_2025, alt: "WomenDay9_2025" },
      { src: WomenDay10_2025, alt: "WomenDay10_2025" }
    ]
  },
  {
    title: "Physio Badminton Tournament - 2025",
    img: [
      { src: Badminton1_2025, alt: "Badminton1_2025" },
      { src: Badminton2_2025, alt: "Badminton2_2025" },
      { src: Badminton3_2025, alt: "Badminton3_2025" },
      { src: Badminton4_2025, alt: "Badminton4_2025" },
      { src: Badminton5_2025, alt: "Badminton5_2025" },
      { src: Badminton6_2025, alt: "Badminton6_2025" }
    ]
  },
  {
    title: "Renaissance - 2024",
    img: [
      { src: renaissance_2024_img_1, alt: "renaissance_2024_img_1" },
      { src: renaissance_2024_img_2, alt: "renaissance_2024_img_2" },
      { src: renaissance_2024_img_3, alt: "renaissance_2024_img_3" },
      { src: renaissance_2024_img_4, alt: "renaissance_2024_img_4" },
      { src: renaissance_2024_img_5, alt: "renaissance_2024_img_5" },
      { src: renaissance_2024_img_6, alt: "renaissance_2024_img_6" },
      { src: renaissance_2024_img_7, alt: "renaissance_2024_img_7" },
      { src: renaissance_2024_img_8, alt: "renaissance_2024_img_8" },
      { src: renaissance_2024_img_9, alt: "renaissance_2024_img_9" },
      { src: renaissance_2024_img_10, alt: "renaissance_2024_img_10" },
      { src: renaissance_2024_img_11, alt: "renaissance_2024_img_11" },
      { src: renaissance_2024_img_12, alt: "renaissance_2024_img_12" },
      { src: renaissance_2024_img_13, alt: "renaissance_2024_img_13" },
      { src: renaissance_2024_img_14, alt: "renaissance_2024_img_14" },
      { src: renaissance_2024_img_15, alt: "renaissance_2024_img_15" },
      { src: renaissance_2024_img_16, alt: "renaissance_2024_img_16" },
      { src: renaissance_2024_img_17, alt: "renaissance_2024_img_17" },
      { src: renaissance_2024_img_18, alt: "renaissance_2024_img_18" },
    ],
  },
  {
    title: "Pro ConTech - 2024",
    img: [
      {
        src: coCurricularEvent_pro_conTech_2024_img_1,
        alt: "coCurricularEvent_pro_conTech_2024_img_1",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_2,
        alt: "coCurricularEvent_pro_conTech_2024_img_2",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_3,
        alt: "coCurricularEvent_pro_conTech_2024_img_3",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_4,
        alt: "coCurricularEvent_pro_conTech_2024_img_4",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_5,
        alt: "coCurricularEvent_pro_conTech_2024_img_5",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_6,
        alt: "coCurricularEvent_pro_conTech_2024_img_6",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_7,
        alt: "coCurricularEvent_pro_conTech_2024_img_7",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_8,
        alt: "coCurricularEvent_pro_conTech_2024_img_8",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_9,
        alt: "coCurricularEvent_pro_conTech_2024_img_9",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_10,
        alt: "coCurricularEvent_pro_conTech_2024_img_10",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_11,
        alt: "coCurricularEvent_pro_conTech_2024_img_11",
      },
      {
        src: coCurricularEvent_pro_conTech_2024_img_12,
        alt: "coCurricularEvent_pro_conTech_2024_img_12",
      },
    ],
  },
  {
    title: "UGAM - 2024",
    img: [
      {
        src: coCurricularEvent_2024_ugam_2024_img_4,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_5,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_6,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_7,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_8,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_9,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_10,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_11,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_12,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_13,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_1,
        alt: "UGAM - 2024 -img -1",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_2,
        alt: "UGAM - 2024 -img -2",
      },
      {
        src: coCurricularEvent_2024_ugam_2024_img_3,
        alt: "UGAM - 2024 -img -3",
      },
    ],
  },
];

const coCurricularEventsData_2023_24: Array<CocoCurricularEventObject> = [
  {
    title: "Renaissance - 2023",
    img: [
      { src: renaissance_2023_24_img_1, alt: "renaissance_2023_24_img_1" },
      { src: renaissance_2023_24_img_2, alt: "renaissance_2023_24_img_2" },
      { src: renaissance_2023_24_img_3, alt: "renaissance_2023_24_img_3" },
      { src: renaissance_2023_24_img_4, alt: "renaissance_2023_24_img_4" },
    ],
  },
];

const coCurricularEventsData_2022_23: Array<CocoCurricularEventObject> = [
  {
    title: "Renaissance - 2022",
    img: [
      { src: renaissance_2022_img_1, alt: "renaissance_2022_img_1" },
      { src: renaissance_2022_img_2, alt: "renaissance_2022_img_2" },
      { src: renaissance_2022_img_3, alt: "renaissance_2022_img_3" },
      { src: renaissance_2022_img_4, alt: "renaissance_2022_img_4" },
      { src: renaissance_2022_img_5, alt: "renaissance_2022_img_5" },
      { src: renaissance_2022_img_6, alt: "renaissance_2022_img_6" },
      { src: renaissance_2022_img_7, alt: "renaissance_2022_img_7" },
      { src: renaissance_2022_img_8, alt: "renaissance_2022_img_8" },
      { src: renaissance_2022_img_9, alt: "renaissance_2022_img_9" },
      { src: renaissance_2022_img_10, alt: "renaissance_2022_img_10" },
      { src: renaissance_2022_img_11, alt: "renaissance_2022_img_11" },
      { src: renaissance_2022_img_12, alt: "renaissance_2022_img_12" },
      { src: renaissance_2022_img_13, alt: "renaissance_2022_img_13" },
      { src: renaissance_2022_img_14, alt: "renaissance_2022_img_14" },
      { src: renaissance_2022_img_15, alt: "renaissance_2022_img_15" },
    ],
  },
  {
    title: "Sports",
    img: [
      { src: sports_img_1, alt: "sports_img_1" },
      { src: sports_img_2, alt: "sports_img_2" },
      { src: sports_img_3, alt: "sports_img_3" },
      { src: sports_img_4, alt: "sports_img_4" },
      { src: sports_img_5, alt: "sports_img_5" },
    ],
  },
];

const coCurricularEventsData_2021_22: Array<CocoCurricularEventObject> = [];

const coCurricularEventsData_2020_21: Array<CocoCurricularEventObject> = [
  {
    title: "Renaissance - 2020",
    img: [
      { src: renaissance_2021_22_img_1, alt: "renaissance_2021_22_img_1" },
      { src: renaissance_2021_22_img_2, alt: "renaissance_2021_22_img_2" },
      { src: renaissance_2021_22_img_3, alt: "renaissance_2021_22_img_3" },
      { src: renaissance_2021_22_img_4, alt: "renaissance_2021_22_img_4" },
      { src: renaissance_2021_22_img_5, alt: "renaissance_2021_22_img_5" },
    ],
  },
];

const coCurricularEventsData_2019_20: Array<CocoCurricularEventObject> = [
  {
    title: "Renaissance - 2019",
    img: [
      { src: renaissance_2019_20_img_1, alt: "renaissance_2019_20_img_1" },
      { src: renaissance_2019_20_img_2, alt: "renaissance_2019_20_img_2" },
      { src: renaissance_2019_20_img_3, alt: "renaissance_2019_20_img_3" },
      { src: renaissance_2019_20_img_4, alt: "renaissance_2019_20_img_4" },
      { src: renaissance_2019_20_img_5, alt: "renaissance_2019_20_img_5" },
    ],
  },
];

const years: Years = [
  { year: "2025-26", data: coCurricularEventsData_2025_26 },
  { year: "2024-25", data: coCurricularEventsData_2024_25 },
  { year: "2023-24", data: coCurricularEventsData_2023_24 },
  { year: "2022-23", data: coCurricularEventsData_2022_23 },
];

const RenderEvent = ({ data }: EventsProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

  return (
    <>
      {data.map((item, index) => {
        const isMultiImages = Array.isArray(item?.img) && item?.img?.length > 1;
        const imageToShow = (item?.img ? item?.img[0]?.src : "") as string;
        return (
          <Grid
            key={index}
            item
            p={2}
            margin={"auto"}
            flexWrap={"wrap"}
            sx={{
              minWidth: {
                xs: "100%",
                md: 400,
              },
              maxWidth: {
                xs: "100%",
                md: 400,
              },
            }}
          >
            <Card
              sx={{
                alignContent: "space-between",
                height: "375px",
                // margin: 4,
                minWidth: {
                  xs: "100%",
                  // md: 400,
                },
                maxWidth: {
                  xs: "100%",
                  // md: 400,
                },
                // minHeight: "380px",
                // maxHeight: { xs: "380px", sm: "380px" },
              }}
            >
              {
                <>
                  {isMultiImages ? (
                    <Box sx={{ position: "relative" }}>
                      <ImageSlideshow
                        sx={{}}
                        images={item?.img as Array<ImageType>}
                        showCaption={false}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item?.title);
                          setSliderImages(item?.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 99,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box sx={{ position: "relative" }}>
                      <CardMedia
                        component="img"
                        height="240px"
                        sx={{
                          pt: 1,
                          margin: "auto",
                          objectFit: "cover",
                        }}
                        image={imageToShow}
                        alt={item?.title as string}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item?.title);
                          setSliderImages(item?.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 2,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                  <Divider sx={{ py: 1 }} />
                </>
              }
              <CardContent>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.contrastText,
                      height: "5x0px"
                    }}
                  >
                    {item?.title}
                  </Typography>

                  {item?.description && (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: theme.palette.grey[900],
                        p: 2,
                      }}
                    >
                      {item?.description}
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
      {data?.length === 0 && <Box sx={{ p: 4 }}>No Data</Box>}
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={
            <Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>
          }
        />
      )}
    </>
  );
};

const CoCurricularEvents = () => {
  const [year, setYear] = useState("2025-26");

  const YearTabs = () => (
    <Grid container spacing={2} justifyContent="center" sx={{ mb: 2 }}>
      {years?.map((item) => (
        <Grid item key={item?.year} xs="auto" sx={{ my: { sm: 1, md: 4 } }}>
          <Chip
            label={item?.year}
            variant="filled"
            sx={{
              color: item?.year === year ? "secondary.main" : "white",
              backgroundColor:
                item?.year === year ? "transparent" : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
            onClick={() => setYear(item?.year)}
          />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <ContentLayout>
      <React.Fragment>
        <YearTabs />

        <RenderEvent
          data={
            years?.find((item) => item.year === year)
              ?.data as Array<CocoCurricularEventObject>
          }
        />
      </React.Fragment>
    </ContentLayout>
  );
};

export default CoCurricularEvents;
